/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React, { PropsWithChildren } from 'react';
import {addCustomEventListener, removeCustomEventListener} from '../util/eventUtil';
import {CustomAppEvent} from '../util/interfaces';
import {generateComponentId} from "../util/componentUtil";

interface Props {
    events: CustomAppEvent | CustomAppEvent[],
    componentName?: string;
}

export default class WithEvents extends React.PureComponent<PropsWithChildren<Props>> {
    private readonly componentName: string;

    constructor(props: Props) {
        super(props);
        this.componentName = generateComponentId(props.componentName);
    }

    componentDidMount = () => {
        const {events} = this.props;
        if (Array.isArray(events))
            for (const event of events)
                addCustomEventListener(this.componentName, event.eventName, event.handler);
        else addCustomEventListener(this.componentName, events.eventName, events.handler);
    };

    componentWillUnmount = () => {
        const {events} = this.props;
        if (Array.isArray(events))
            for (const event of events)
                removeCustomEventListener(this.componentName, event.eventName);
        else removeCustomEventListener(this.componentName, events.eventName);
    };

    render = () => this.props.children;
}
